export const blockInvalidChar = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
